import {
  FETCH_TICKET_LIST_REQUEST,
  FETCH_TICKET_LIST_SUCCESS,
  FETCH_TICKET_LIST_FAILURE,
  FETCH_TICKET_DETAILS_REQUEST,
  FETCH_TICKET_DETAILS_SUCCESS,
  FETCH_TICKET_DETAILS_FAILURE,
  CREATE_TICKET_BOOKING_REQUEST,
  CREATE_TICKET_BOOKING_SUCCESS,
  CREATE_TICKET_BOOKING_FAILURE,
  UPDATE_TICKET_PAYMENT_FAILURE,
  UPDATE_TICKET_PAYMENT_REQUEST,
  UPDATE_TICKET_PAYMENT_SUCCESS,
  FETCH_MY_TICKET_REQUEST,
  FETCH_MY_TICKET_SUCCESS,
  FETCH_MY_TICKET_FAILURE,
  FETCH_MY_TICKET_DETAILS_REQUEST,
  FETCH_MY_TICKET_DETAILS_SUCCESS,
  FETCH_MY_TICKET_DETAILS_FAILURE,
  TICKET_DOWNLOAD_INVOICE_REQUEST,
  TICKET_DOWNLOAD_INVOICE_FAILURE,
  TICKET_DOWNLOAD_INVOICE_SUCCESS,
  CANCEL_TICKET_REQUEST,
  CANCEL_TICKET_FAILURE,
  CANCEL_TICKET_SUCCESS,
} from "./actionTYpes";

const initialState = {
  loading: false,
  ticket_list: [],
  my_ticket_list: [],
  my_ticket_details: [],
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  itemsPerPage: 10,
  error: "",

  // For single venue details
  ticket_details: null,
  loadingDetails: false,
  errorDetails: "",

  // for booking status details
  booking_status_loading: false,
  booking_status_error: "",
  booking_status_data: null,

  // New fields for “update payment status”
  updateLoading: false,
  updateError: "",
  updateResult: null,

  // cancel ticket
  cancelStatusLoading: false,
  cancelStatusError: "",
  cancelResult: null,
};

const initialTicketBookingState = {
  loading: false,
  booking_list: [],
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  itemsPerPage: 10,
  error: "",
};

export const TicketBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TICKET_LIST_REQUEST:
      return { ...state, loading: true };

    case FETCH_TICKET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        ticket_list: action?.payload?.data,
        totalItems: action?.payload?.pagination?.total,
        totalPages: action?.payload?.total_pages,
        currentPage: action?.payload?.page,
        itemsPerPage: action?.payload?.itemsPerPage,
        error: "",
      };

    case FETCH_TICKET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case FETCH_TICKET_DETAILS_REQUEST:
      return {
        ...state,
        loadingDetails: true,
        errorDetails: "",
        ticket_details: null,
      };

    case FETCH_TICKET_DETAILS_SUCCESS:
      return {
        ...state,
        loadingDetails: false,
        ticket_details: action.payload,
        errorDetails: "",
      };

    case FETCH_TICKET_DETAILS_FAILURE:
      return {
        ...state,
        loadingDetails: false,
        errorDetails: action.payload,
      };

    case CREATE_TICKET_BOOKING_REQUEST:
      return {
        ...state,
        booking_status_loading: true,
        booking_status_error: "",
        booking_status_data: null,
      };

    case CREATE_TICKET_BOOKING_SUCCESS:
      return {
        ...state,
        booking_status_loading: false,
        booking_status_data: action.payload,
        booking_status_error: "",
      };

    case CREATE_TICKET_BOOKING_FAILURE:
      return {
        ...state,
        booking_status_loading: false,
        booking_status_error: action.payload,
      };

    case UPDATE_TICKET_PAYMENT_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        // whatever the API returns, e.g. updated payment-status object
        updateResult: action.payload,
        updateError: "",
      };

    case UPDATE_TICKET_PAYMENT_FAILURE:
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload || "Failed to update payment status",
        updateResult: null,
      };

    case UPDATE_TICKET_PAYMENT_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: "",
        updateResult: null,
      };

    case FETCH_MY_TICKET_REQUEST:
      return { ...state, loading: true };

    case FETCH_MY_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        my_ticket_list: action?.payload?.data || [],
        totalItems: action?.payload?.data?.pagination?.total || 0,
        totalPages: action?.payload?.data?.pagination?.totalPages || 0,
        apiCurrentPage: action?.payload?.data?.pagination?.page || 1,
        apiItemsPerPage: action?.payload?.data?.pagination?.limit || 10,
        error: "",
      };

    case FETCH_MY_TICKET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Something went wrong",
      };

    case FETCH_MY_TICKET_DETAILS_REQUEST:
      return { ...state, loading: true };

    case FETCH_MY_TICKET_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        my_ticket_details: action?.payload?.bookingDetails || [],
        error: "",
      };

    case FETCH_MY_TICKET_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Something went wrong",
      };

    case TICKET_DOWNLOAD_INVOICE_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: "",
        updateResult: null,
      };

    case TICKET_DOWNLOAD_INVOICE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateResult: action.payload,
        updateError: "",
      };

    case TICKET_DOWNLOAD_INVOICE_FAILURE:
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload || "Failed to update payment status",
        updateResult: null,
      };

    case CANCEL_TICKET_REQUEST:
      return {
        ...state,
        cancelStatusLoading: true,
        cancelStatusError: "",
      };

    case CANCEL_TICKET_SUCCESS:
      return {
        ...state,
        cancelStatusLoading: false,
        cancelResult: action.payload,
      };

    case CANCEL_TICKET_FAILURE:
      return {
        ...state,
        cancelStatusLoading: false,
        cancelStatusError: action.payload,
      };

    default:
      return state;
  }
};
